export enum CompanyRelation {
  ALL = 'true',
  NONE = 'false',
  CATEGORY = 'category',
  COUNTRY = 'country',
  SERVICES = 'services',
  SERVICEGROUPS = 'serviceproups'
}
